export const Img = ({ img, className = "", priority = false, sizes = "(min-width: 1024px) 50vw, 100vw", label = true, testid }) => (
  <figure className={`${className.includes("absolute") ? "" : "relative"} overflow-hidden ${className}`} data-testid={testid}>
    <img
      src={`/assets/images/${img.base}-1280.webp`}
      srcSet={`/assets/images/${img.base}-640.webp 640w, /assets/images/${img.base}-800.webp 800w, /assets/images/${img.base}-1280.webp 1280w`}
      sizes={sizes}
      width={img.w}
      height={img.h}
      alt={img.alt}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      className="h-full w-full object-cover"
    />
    {label && (
      <figcaption className="absolute left-3 top-3 rounded-full bg-ink/85 px-3 py-1 text-[0.72rem] font-medium uppercase tracking-[0.14em] text-bone backdrop-blur">
        Illustrative scene
      </figcaption>
    )}
  </figure>
);
